module.exports = __webpack_public_path__ + "static/process_exporting2_1-3d1fa5dd58b9f9db05c5c2d0d8b9bdff.jpg";